// 好老师智库
export default {
    path: "/teacherGood",
    name: "teacherGood",
    component: () => import("../views/teacherGood/index.vue"),
    children: [
        {
            path: "/teacherGood/teacherGoodIndex",
            name: "teacherGood-teacherGoodIndex",
            component: () => import("../views/teacherGood/teacherGoodIndex.vue"),
        },
        {
            path: "/teacherGood/teacherDetail",
            name: "teacherGood-teacherDetail",
            component: () => import("../views/teacherGood/teacherDetail.vue"),
        }
    ]
}